import { clamp } from 'lodash';

export interface SiteHeaderResponsiveLayout {
  labSelectWidth: number;
  originsIconOnly: boolean;
  resultsModeIconOnly: boolean;
  userMenuIconOnly: boolean;
  userMenuMaxWidth: number;
  copilotTriggerIconOnly: boolean;
  clusterBoundaryGap: number;
  leftClusterGap: number;
  rightClusterGap: number;
  controlPanelGap: number;
}

interface SiteHeaderResponsiveLayoutOptions {
  preferCompactControls?: boolean;
}

const defaultSiteHeaderAvailableWidth = 1280;
const openDrawerResponsiveWidthPenalty = 220;

export const getSiteHeaderResponsiveLayout = (
  availableWidth: number,
  { preferCompactControls = false }: SiteHeaderResponsiveLayoutOptions = {}
): SiteHeaderResponsiveLayout => {
  const normalizedWidth =
    Number.isFinite(availableWidth) && availableWidth > 0 ? availableWidth : defaultSiteHeaderAvailableWidth;
  const responsiveWidth = Math.max(0, normalizedWidth - (preferCompactControls ? openDrawerResponsiveWidthPenalty : 0));

  return {
    labSelectWidth: clamp(Math.round(responsiveWidth * 0.22), 148, 260),
    originsIconOnly: responsiveWidth < 1240,
    resultsModeIconOnly: responsiveWidth < 1140,
    userMenuIconOnly: responsiveWidth < 1000,
    userMenuMaxWidth: clamp(Math.round(responsiveWidth * 0.18), 136, 240),
    copilotTriggerIconOnly: responsiveWidth < 920,
    clusterBoundaryGap: responsiveWidth < 1120 ? 1 : 1.5,
    leftClusterGap: responsiveWidth < 1120 ? 1 : 2,
    rightClusterGap: responsiveWidth < 1120 ? 0.5 : 1,
    controlPanelGap: responsiveWidth < 1080 ? 0.5 : 1,
  };
};
